module.exports = __webpack_public_path__ + "media/images/vp/icon.submenu.history.red-dfaff0c470b93bfac20ab8a93f6678d8.svg";